export { PaymentPageContainer as PaymentPage } from "./container";
